export const MIN_DESCRIPTION_HEIGHT = 67;
